export function safeJsonParse(text) {
    if (!text) return null;

    try {
        return JSON.parse(text);
    } catch {
        return null;
    }
}
